import { TranslateService } from '@ngx-translate/core';

import { epicDependencies } from '../../../store';
import { SearchItem } from '../../core';
import { TranslationKeyMap } from '../landing.i18n';
import { ColumnId } from '../model/column-id.model';
import { SelectedFilterOption } from '../model/filter-criteria-item.model';
import { FilterOption } from '../model/filter-option.model';

function createAccessor(columnId: ColumnId): (e: SearchItem) => any {
    switch (columnId) {
        case ColumnId.USER_NAME:
            return (e) => e.targetUserName ?? '-';
        case ColumnId.MANAGER:
            return (e) => e.targetManagerUserName ?? '-';
        case ColumnId.EVALUATOR:
            return (e) => e.evaluatorUserName ?? '-';
        case ColumnId.EVALUATION_NAME:
            return (e) => e.evaluationName ?? '-';
        case ColumnId.STATUS:
            // eslint-disable-next-line no-case-declarations
            const tl =
                epicDependencies.injector.get<TranslateService>(
                    TranslateService,
                ); // TODO FIXME revise
            return (e) =>
                tl.instant(
                    e.draftId != null
                        ? TranslationKeyMap._9476_DRAFT
                        : TranslationKeyMap._9113_PUBLISHED,
                );
        default:
            return null;
    }
}

function applyFilter(
    columnFilters: Map<ColumnId, SelectedFilterOption[]>,
    row: SearchItem,
): boolean {
    let isValid = true;
    columnFilters.forEach((filters, columnId) => {
        const accessor = createAccessor(columnId);
        if (!accessor) {
            return;
        }
        const rowValue = accessor(row);
        const hasMatchingFilter = filters.some(
            (filter) => rowValue === filter.value,
        );
        isValid = isValid && hasMatchingFilter;
    });
    return isValid;
}

export function createFilterOpts(
    rows: SearchItem[],
    columnId: ColumnId,
): FilterOption[] {
    if (rows == null) {
        return [];
    }
    const accessor = createAccessor(columnId);
    if (accessor == null) {
        return [];
    }
    const opts: FilterOption[] = rows.map((e) => ({
        value: accessor(e),
        label: accessor(e),
        isSelected: false,
    }));
    const seen = [];
    return opts
        .filter((e) => {
            if (seen.includes(e.value)) {
                return false;
            }
            seen.push(e.value);
            return true;
        })
        .sort((a, b) => {
            if (typeof a.value === 'string' && typeof b.value === 'string') {
                return a.value.localeCompare(b.value);
            }
            return Number.MIN_SAFE_INTEGER;
        });
}

export function filterRows(
    rows: SearchItem[],
    filters: SelectedFilterOption[],
): SearchItem[] {
    if (rows == null) {
        return null;
    }

    if (filters == null || filters?.length === 0) {
        return rows;
    }

    const columnFilters = new Map<ColumnId, SelectedFilterOption[]>();
    filters.forEach((filter) => {
        if (columnFilters.has(filter.columnId)) {
            columnFilters.get(filter.columnId).push(filter);
        } else {
            columnFilters.set(filter.columnId, [filter]);
        }
    });
    return rows.filter((row) => applyFilter(columnFilters, row));
}
